import {
  type CreateIntercityOrderResponse,
  type CreateNewOrderRequestBody,
  type DefaultQueryError,
  createNewOrderFn,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export const useCreateNewOrder = (
  opts?: UseMutationOptions<
    CreateIntercityOrderResponse,
    DefaultQueryError,
    CreateNewOrderRequestBody
  >
) =>
  useMutation<
    CreateIntercityOrderResponse,
    DefaultQueryError,
    CreateNewOrderRequestBody
  >({
    mutationFn: createNewOrderFn,
    ...opts,
  });
